import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/** One "Open Loans by Lender" row (PRD §3.8). */
export interface OpenLoanByLender {
  smeId: string;
  smeName: string | null;
  lender: string | null;
  facility: string;
  outstandingEur: number;
  settlementStatus: string;
  settlementBadge: string;
}

/** One settlement-history row (PRD §1.8) — net = gross − commission, STL-yyyyMMdd-nnn ref. */
export interface SettlementRow {
  settlementDate: string;
  period: string;
  grossEur: number;
  commissionEur: number;
  netEur: number;
  status: string;
  statusBadge: string;
  reference: string;
}

/** The calling E-D's settlements view (PRD §3.8). */
export interface SettlementView {
  openLoans: OpenLoanByLender[];
  history: SettlementRow[];
  pendingSettlementEur: number;
  pendingSettlementDate: string | null;
  lastSettlementEur: number;
  lastSettlementDate: string | null;
  lastSettlementReference: string | null;
  settlementDataAvailable: boolean;
}

/** Optional settlement-date window. */
export interface SettlementQuery {
  from?: string | null;
  to?: string | null;
}

/**
 * DI token for the E-D Settlements API (PRD §3.8 / §2.5, EM-834/835). Bound to
 * `EdSettlementRestService`. E-D-scoped server-side (Rule 22). REST-only (Rules 07/10).
 */
export interface EdSettlementApi {
  /** GET /services/embedded/api/v1/ed/settlement?from&to */
  getSettlements(query: SettlementQuery): Observable<SettlementView>;
  /** GET /services/embedded/api/v1/ed/settlement/export?format=pdf|xlsx — returns a Blob */
  exportSettlements(format: 'pdf' | 'xlsx', query: SettlementQuery): Observable<Blob>;
}

export const ED_SETTLEMENT = new InjectionToken<EdSettlementApi>('ED_SETTLEMENT');
